import axios, { AxiosInstance, AxiosResponse } from 'axios';
//import { application, getBaseApiUrl } from '../../initialize';
import { debugLog } from '../../utils';
import { IType } from '../types';
//import { debugLog } from '../../common/Logger';
import { fetchError } from './fetchError';
import { getAccessToken } from '../../Authentication';

const responseGet = (response: AxiosResponse) => 
	response.data;

const responsePut = (response: AxiosResponse) =>
	//debugLog(`Response PUT: ${JSON.stringify(response.data)}`);
	response.data;

const responseDelete = (response: AxiosResponse) => {
	debugLog(`Response DELETE: ${JSON.stringify(response.data)}`);
	//response.data;
}

let updateFetch: AxiosInstance;

const setResponse = (instance: AxiosInstance) => {
	instance.interceptors.response.use(
		//response => response,
		undefined,
		error => {
			const err = fetchError(error.response, error.message, error.config);
			return Promise.reject(err);
		});
}

const initializeDefaultAxios = (baseURL: string) => {
	//debugLog('location:' );
	//debugLog(window.location );
	//debugLog('URL: ' + baseApiUrl + ' HostUrl: ' + hostApiUrl() );
	axios.defaults.baseURL = baseURL;
	axios.interceptors.request.use(
		async (config) => {
			//config.mode = 'cors', // no-cors, *cors, same-origin
			config.headers['Accept'] = 'application/json';
			config.headers['Content-Type'] = 'application/json';
			config.headers.Authorization = `Bearer ${await getAccessToken()}`;
			return config;
		},
		error => Promise.reject(error)
	);

	setResponse(axios);
}

const initializeAxiosUpdate = (baseURL: string) => {
	updateFetch = axios.create({
		baseURL,
		headers: { 
			//'Content-Type': 'application/x-www-form-urlencoded' 
			'Content-Type': 'application/json'
		}
	});

	updateFetch.interceptors.request.use(
		async (config) => {
			config.headers.Authorization = `Bearer ${await getAccessToken()}`;
			return config;
		},
		error => Promise.reject(error)
	);

	setResponse(updateFetch);
}

export const initializeAxios = (baseURL: string) => {
	//debugLog('location:' );
	//debugLog(window.location );
	//debugLog('URL: ' + baseApiUrl + ' HostUrl: ' + hostApiUrl() );
	initializeDefaultAxios(baseURL);
	initializeAxiosUpdate(baseURL);
}

export const Fetch = {
	get: (url: string) => 
		axios.get(url).then(responseGet),

	getTypes: (url: string ): Promise<IType[]> =>
		axios.get(url).then( (response: AxiosResponse) =>
			response.data && response.data.Data ? response.data.Data.map((a: any) => {
				return { label: a.Name, value: a.Id }
			}) : []),

	buildUrl: (url: string, query?: string): string =>
		(query && query.length) ? `${url}?${query}` : url,

	getByQuery: (url: string, query?: string) =>
		axios.get(Fetch.buildUrl(url, query)).then(responseGet),
	
	post: (url: string, body: any) =>
		updateFetch.post(url, body).then(responsePut),

	put: (url: string, body: any) =>
		updateFetch.put(url, body).then(responsePut),

	del: (url: string, body?:any ) =>
		updateFetch.delete(url, { data: body} ).then(responseDelete)
};
